export default __webpack_public_path__ + "f2be554ffb9721cc11d826043ce78bdf.png";